module.exports = __webpack_public_path__ + "img/sub-banner-1.9bd58584.jpg";